import { render, staticRenderFns } from "./Fetch.vue?vue&type=template&id=061ca28a&"
import script from "./Fetch.vue?vue&type=script&lang=js&"
export * from "./Fetch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Fetch.vue"
export default component.exports